import { render, staticRenderFns } from "./menu2_images_scence_q.vue?vue&type=template&id=78b2e6d4&scoped=true"
import script from "./menu2_images_scence_q.vue?vue&type=script&lang=js"
export * from "./menu2_images_scence_q.vue?vue&type=script&lang=js"
import style0 from "./menu2_images_scence_q.vue?vue&type=style&index=0&id=78b2e6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b2e6d4",
  null
  
)

export default component.exports